import React from "react";
import { Button } from "antd";
import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function WebsiteFooter() {

    const handleRedirect = (url) => {
        // Sends the user to the specified external website URL
        window.location.href = url;
    };


    return (
        <footer className="bg-white border-t border-slate-100">
            <div className="max-w-[1200px] mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
                    <div className="md:col-span-1">
                        <div className="flex items-center ">
                            <img width={300} src="https://i.ibb.co/HTJMwrc0/crop-logo-shipless.png" />

                        </div>

                        <p className="text-slate-500 mt-4 ml-4">
                            AI-powered image optimization to reduce Meesho shipping charges.
                        </p>
                    </div>



                    <FooterLinks
                        title="Quick Links"
                        links={[
                            { name: "How It Works", path: "/how-it-works" },
                            { name: "Features", path: "/features" },
                            { name: "Pricing", path: "/pricing" },
                            { name: "FAQs", path: "/faq" },
                        ]}
                    />

                    <FooterLinks
                        title="Company"
                        links={[
                            { name: "About Us", path: "/about-us" },
                            { name: "Contact Us", path: "/contact" },
                            { name: "Privacy Policy", path: "/privacy" },
                            { name: "Terms & Conditions", path: "/terms" },
                            { name: "Refund Policy", path: "/refund-policy" },
                        ]}
                    />

                    <FooterLinks
                        title="Support"
                        links={[
                            { name: "Help Center", path: "/contact" },
                            { name: "Contact Support", path: "/contact" },

                        ]}
                    />


                    {/* <div>
                        <h3 className="font-bold">Have Questions?</h3>
                        <p className="text-slate-500">Chat with us on WhatsApp</p>
                        <Button onClick={() => handleRedirect('https://wa.me/918602490161?text=Hi Shipless Tool')} className="bg-green-100 text-green-700 border-green-200">
                            Chat on WhatsApp
                        </Button>
                    </div> */}
                </div>

                <div className="border-t mt-10 pt-6 flex flex-col md:flex-row justify-between text-slate-500 text-sm">
                    <div>
                        <p>© 2026 ShipLess AI. All rights reserved.</p>
                        <p className="m-0">
                            Legal Name: <b>GWALAX ONLINE SERVICES</b>
                        </p>
                    </div>

                    <p>Made with 💜 for Meesho Sellers</p>
                </div>
            </div>
        </footer>
    );
}


function FooterLinks({ title, links }) {
    return (
        <div>
            <h3 className="font-bold mb-4">{title}</h3>

            <div className="flex flex-col gap-2">
                {links.map((link, index) => (
                    <Link
                        key={index}
                        to={link.path}
                        className="text-slate-600 hover:text-purple-600 transition"
                    >
                        {link.name}
                    </Link>
                ))}
            </div>
        </div>
    );
}